import { render, staticRenderFns } from "./home.vue?vue&type=template&id=baed0f22&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=baed0f22&prod&lang=css"
import style1 from "./home.vue?vue&type=style&index=1&id=baed0f22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baed0f22",
  null
  
)

export default component.exports